import { useStore } from '../../stores/useStore'

export default function Mixer() {
  const tracks = useStore((state) => state.tracks)
  const updateTrack = useStore((state) => state.updateTrack)

  return (
    <div className="mixer">
      <h2>Mixer</h2>
      <div className="mixer-channels">
        {tracks.map((track) => {
          const trackInstrument = useStore.getState().modules.find((m) => m.id === track.instrumentId)
          const instrumentName = trackInstrument?.name ?? track.name
          return (
            <div key={track.id} className="mixer-channel">
              <div className="channel-header">
                <div className="channel-color" style={{ background: track.color }} />
                <div className="channel-name">{instrumentName}</div>
              </div>

              <div className="channel-controls">
                <div className="control-row">
                  <label>VOL</label>
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={track.volume}
                    onChange={(e) => updateTrack(track.id, { volume: parseFloat(e.target.value) })}
                    className="slider"
                  />
                  <span className="value-display">{Math.round(track.volume * 100)}</span>
                </div>

                <div className="control-row">
                  <label>PAN</label>
                  <input
                    type="range"
                    min="-1"
                    max="1"
                    step="0.01"
                    value={track.pan}
                    onChange={(e) => updateTrack(track.id, { pan: parseFloat(e.target.value) })}
                    className="slider"
                  />
                  <span className="value-display">{track.pan <= 0 ? 'L' : 'R'}</span>
                </div>

                <div className="channel-buttons">
                  <button
                    className={`btn ${track.muted ? 'btn-danger' : ''}`}
                    onClick={() => updateTrack(track.id, { muted: !track.muted })}
                  >
                    MUTE
                  </button>
                  <button
                    className={`btn ${track.soloed ? 'btn-primary' : ''}`}
                    onClick={() => updateTrack(track.id, { soloed: !track.soloed })}
                  >
                    SOLO
                  </button>
                  <button
                    className={`btn ${track.enabled ? '' : 'btn-danger'}`}
                    onClick={() => updateTrack(track.id, { enabled: !track.enabled })}
                  >
                    {track.enabled ? 'ON' : 'OFF'}
                  </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
